// extracted by mini-css-extract-plugin
module.exports = {"stage":"stage--5unJY"};